"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorHandler = function (error) {
    var response = error.response;
    var status = response.status, data = response.data;
    var message = data.message;
    return Promise.reject({ message: message, status: status, data: data });
};
exports.requestHandler = function (request) { return request; };
exports.responseHandler = function (response) { return response; };
